import React, { useState } from "react";
import { Container, Row, Col, Button, Offcanvas } from "react-bootstrap";
import "./InteractiveImageGrid.css";

const imageData = [
  { src: require("./images/image1.jpg"), 
    alt: "ซักประวัติ ตรวจร่างกาย",
    description: (
      <>
        <p>การซักประวัติและตรวจร่างกายโรคหัวใจ</p>
        <p>
          การซักประวัติเป็นขั้นตอนแรกและสำคัญมากในการวินิจฉัยโรคหัวใจ แพทย์จะสอบถามถึงอาการต่างๆ ที่คุณรู้สึก เช่น:
        </p>
        <ul>
          <li>ความรู้สึกไม่สบายหน้าอก: อาจเป็นอาการแน่น เจ็บ แสบ หรือปวด</li>
          <li>เหนื่อยง่าย: แม้ทำกิจวัตรประจำวัน</li>
          <li>ใจสั่น: รู้สึกหัวใจเต้นเร็วหรือผิดจังหวะ</li>
          <li>บวม: โดยเฉพาะที่ขาและเท้า</li>
          <li>หน้ามืด: หรือเป็นลม</li>
          <li>ประวัติครอบครัว: มีใครในครอบครัวเป็นโรคหัวใจหรือไม่</li>
        </ul>
        <p>
          การตรวจร่างกาย แพทย์จะทำการตรวจร่างกายทั่วไป และเน้นที่ระบบหัวใจและหลอดเลือด เช่น:
        </p>
        <ul>
          <li>ฟังเสียงหัวใจ: เพื่อตรวจหาเสียงผิดปกติที่อาจบ่งบอกถึงโรคหัวใจ</li>
          <li>วัดความดันโลหิต: เพื่อประเมินสุขภาพของหลอดเลือด</li>
          <li>ตรวจชีพจร: เพื่อดูอัตราการเต้นของหัวใจและความสม่ำเสมอ</li>
          <li>ตรวจปอด: เพื่อดูว่ามีของเหลวคั่งในปอดหรือไม่ ซึ่งอาจเกิดจากภาวะหัวใจล้มเหลว</li>
        </ul>
        <p>
          นอกจากนี้ แพทย์อาจสั่งตรวจเพิ่มเติม เช่น:
        </p>
        <ul>
          <li>คลื่นไฟฟ้าหัวใจ (ECG): เพื่อตรวจวัดกระแสไฟฟ้าของหัวใจ</li>
          <li>เอกซเรย์ทรวงอก: เพื่อดูขนาดและรูปร่างของหัวใจ</li>
          <li>อัลตร้าซาวด์หัวใจ (Echo): เพื่อดูโครงสร้างและการทำงานของหัวใจ</li>
          <li>ตรวจเลือด: เพื่อประเมินระดับคอเลสเตอรอล ไขมันในเลือด และความผิดปกติอื่นๆ</li>
        </ul>
        <p>
          <strong>คำแนะนำ:</strong> หากคุณมีอาการที่น่าสงสัยเกี่ยวกับโรคหัวใจ ควรรีบปรึกษาแพทย์เพื่อรับการวินิจฉัยและรักษาที่ถูกต้อง
        </p>
      </>
    ),
  },
  { src: require("./images/image2.jpg"), 
    alt: "ตรวจคลื่นไฟฟ้าหัวใจ (ECG)", 
    description: (
    <>
<p>การตรวจคลื่นไฟฟ้าหัวใจ (ECG) </p>
<p>ECG หรือElectrocardiogram เป็นการตรวจที่ใช้คลื่นไฟฟ้าเพื่อวัดกิจกรรมทางไฟฟ้าของหัวใจ ซึ่งจะแสดงออกมาในรูปแบบของกราฟ ช่วยให้แพทย์ประเมินสุขภาพของหัวใจได้อย่างรวดเร็วและแม่นยำ
ทำไมต้องตรวจ ECG? </p>
<ul>
<li>ตรวจหาความผิดปกติของหัวใจ: เช่น จังหวะหัวใจผิดปกติ กล้ามเนื้อหัวใจเสียหาย หรือภาวะหัวใจขาดเลือด</li>
<li>ติดตามอาการของโรคหัวใจ: เช่น หลังการผ่าตัดหัวใจ หรือการใช้ยาบางชนิด</li>
<li>ตรวจสุขภาพประจำปี: เพื่อค้นหาความเสี่ยงของโรคหัวใจก่อนที่จะมีอาการ</li>
</ul>
<p>ขั้นตอนการตรวจ</p>
<ul>
<li>เตรียมตัว: ผู้ป่วยจะต้องถอดเสื้อผ้าส่วนบน และนอนราบลงบนเตียง</li>
<li>ติดแผ่นอิเล็กโทรด: แพทย์หรือพยาบาลจะติดแผ่นอิเล็กโทรดเล็กๆ บริเวณหน้าอก แขน และขา เพื่อรับสัญญาณไฟฟ้าจากหัวใจ</li>
<li>บันทึกคลื่นไฟฟ้า: เครื่อง ECG จะบันทึกคลื่นไฟฟ้าของหัวใจเป็นเวลาประมาณ 5-10 นาที</li>
 </ul>
<p>ผลการตรวจ</p>
<p>ผลการตรวจ ECG จะแสดงเป็นกราฟที่แพทย์จะนำไปวิเคราะห์เพื่อหาความผิดปกติต่างๆ เช่น</p>
<ul>
<li>อัตราการเต้นของหัวใจ: เร็วเกินไป ช้าเกินไป หรือไม่สม่ำเสมอ</li>
<li>จังหวะการเต้นของหัวใจ: มีการเต้นผิดปกติหรือไม่</li>
<li>ขนาดของหัวใจ: มีการขยายตัวหรือไม่</li>
<li>ความเสียหายของกล้ามเนื้อหัวใจ: มีการเปลี่ยนแปลงของคลื่นไฟฟ้าที่บ่งบอกถึงความเสียหายของกล้ามเนื้อหัวใจหรือไม่</li>
</ul>
<p>ข้อดีของการตรวจ ECG</p>
<ul>
<li>รวดเร็วและไม่เจ็บปวด: การตรวจใช้เวลาเพียงไม่กี่นาที และไม่ก่อให้เกิดความเจ็บปวด</li>
<li>ไม่รุกล้ำ: ไม่ต้องใช้สารทึบแสงหรือการฉีดสารใดๆ เข้าสู่ร่างกาย</li>
<li>ให้ข้อมูลที่เป็นประโยชน์: ช่วยให้แพทย์วินิจฉัยโรคหัวใจและวางแผนการรักษาได้อย่างเหมาะสม</li>
</ul>
<p>หากคุณมีข้อสงสัยเพิ่มเติมเกี่ยวกับการตรวจ ECG สามารถปรึกษาแพทย์ได้</p>
</>
  ),
},
  { src: require("./images/image3.jpg"), 
    alt: "ตรวจอัลตราซาวน์หัวใจ-เอคโค่ (Echocadiography)", 
    description: (
      <>
<p>การตรวจอัลตราซาวหัวใจ หรือเอคโค่หัวใจ  (Echocardiography หรือEcho หัวใจ)</p>
<p>การตรวจเอคโค่หัวใจ คือการตรวจหัวใจโดยใช้คลื่นเสียงความถี่สูง (ultrasound) เพื่อสร้างภาพของหัวใจและหลอดเลือดใหญ่ ทำให้แพทย์สามารถประเมินการทำงานของหัวใจได้อย่างละเอียด เป็นการตรวจที่ปลอดภัย ไม่เจ็บ และใช้เวลาน้อย</p>
<p>ทำไมต้องตรวจ Echo หัวใจ?</p>
<ul>
 <li>ตรวจหาโรคหัวใจ: เช่น โรคลิ้นหัวใจตีบหรือรั่ว, กล้ามเนื้อหัวใจอ่อนแรง, หัวใจโต, ภาวะหัวใจล้มเหลว</li>
 <li>ติดตามอาการของโรคหัวใจ: หลังการผ่าตัดหัวใจ หรือการรักษาโรคหัวใจ</li>
 <li>ประเมินความเสี่ยงก่อนการผ่าตัด: เช่น การผ่าตัดใหญ่</li>
 <li>ตรวจสุขภาพประจำปี: สำหรับผู้ที่มีความเสี่ยงสูงต่อโรคหัวใจ</li>
</ul>
<p>การตรวจเป็นอย่างไร?</p>
<ul>
 <li>เตรียมตัว: ผู้ป่วยจะต้องนอนราบ และอาจจะต้องงดอาหารและน้ำก่อนตรวจ</li>
 <li>ใช้เจล: แพทย์จะทาเจลลื่นๆ บนหน้าอก เพื่อช่วยให้คลื่นเสียงส่งผ่านได้ดี</li>
 <li>สแกน: แพทย์จะใช้หัวตรวจเคลื่อนที่ไปมาบนหน้าอก เพื่อเก็บภาพของหัวใจ</li>
 <li>วิเคราะห์ผล: แพทย์จะนำภาพที่ได้ไปวิเคราะห์ และให้คำแนะนำ</li>
</ul>
<p>การตรวจ Echo หัวใจบอกอะไรเราได้บ้าง?</p>
<ul>
 <li>ขนาดและรูปร่างของหัวใจ: ตรวจพบหัวใจโตหรือผิดรูป</li>
 <li>การทำงานของกล้ามเนื้อหัวใจ: ตรวจพบกล้ามเนื้อหัวใจอ่อนแรง หรือหนาตัวผิดปกติ</li>
 <li>การทำงานของลิ้นหัวใจ: ตรวจพบลิ้นหัวใจตีบหรือรั่ว</li>
 <li>การไหลเวียนของเลือด: ตรวจพบความผิดปกติของการไหลเวียนเลือดในหัวใจ</li>
 <li>ตำแหน่งของหลอดเลือด: ตรวจพบหลอดเลือดหัวใจตีบ หรือความผิดปกติอื่นๆ</li>
</ul>
<p>ข้อดีของการตรวจ Echo หัวใจ</p>
<ul>
 <li>ปลอดภัย: ไม่ใช้รังสี</li>
 <li>ไม่เจ็บ: ผู้ป่วยรู้สึกเพียงความเย็นจากเจล</li>
 <li>รวดเร็ว: ใช้เวลาประมาณ 30 นาที</li>
 <li>แม่นยำ: ให้ข้อมูลเกี่ยวกับหัวใจได้อย่างละเอียด</li>
</ul>
<p>หากคุณมีข้อสงสัยเพิ่มเติม สามารถปรึกษาแพทย์ได้</p>
</>
  ), 
},
  { src: require("./images/image4.jpg"), 
    alt: "ตรวจคลื่นไฟฟ้าหัวใจชนิดพกพา (Holter monitoring)", 
    description: (
      <>
      <p>การตรวจ Holter Monitoring: ตรวจหัวใจแบบพกพา ตลอด 24 ชั่วโมง</p>
      <p>Holter Monitoring คือการตรวจคลื่นไฟฟ้าหัวใจแบบพกพาที่ใช้บันทึกการทำงานของหัวใจตลอด 24 ชั่วโมง หรืออาจมากกว่านั้น เพื่อตรวจหาความผิดปกติของจังหวะการเต้นของหัวใจที่อาจเกิดขึ้นได้เป็นครั้งคราว เช่น วูบเป็นลม หมดสติ ใจสั่น หรือหัวใจเต้นเร็ว ซึ่งการตรวจคลื่นไฟฟ้าหัวใจแบบปกติอาจตรวจไม่พบ</p>
      <p>เหตุผลที่ต้องทำการตรวจ Holter Monitoring</p>
      <ul>
       <li>ตรวจหาสาเหตุของอาการใจสั่นหรือวูบเป็นลม: หากคุณรู้สึกใจสั่นบ่อยๆ การตรวจ Holter จะช่วยระบุชนิดและความถี่ของการเกิดอาการใจสั่นได้ หรือหัวใจเต้นช้าทำให้วูบเป็นลม หมดสติ</li>
       <li>ตรวจหาภาวะหัวใจเต้นผิดจังหวะ: การตรวจนี้จะช่วยตรวจพบความผิดปกติของจังหวะการเต้นของหัวใจที่อาจนำไปสู่ภาวะแทรกซ้อนอื่นๆ ได้</li>
       <li>ประเมินประสิทธิภาพของยา: หากคุณกำลังรับประทานยาเพื่อควบคุมจังหวะการเต้นของหัวใจ การตรวจ Holter จะช่วยประเมินประสิทธิภาพของยาได้</li>
      </ul>
      <p>ขั้นตอนการตรวจ</p>
      <ul>
       <li>ติดตั้งอุปกรณ์: แพทย์จะติดแผ่นอิเล็กโทรดขนาดเล็กเข้ากับผิวหนังบริเวณหน้าอก เพื่อเชื่อมต่อกับเครื่องบันทึกคลื่นไฟฟ้าหัวใจขนาดเล็กที่คุณจะต้องพกติดตัวไป</li>
       <li>ใช้ชีวิตประจำวัน: ในระหว่างการตรวจ คุณสามารถทำกิจวัตรประจำวันได้ตามปกติ</li>
       <li>วิเคราะห์ผล: หลังจากผ่านไป 24-48 ชั่วโมง คุณจะนำอุปกรณ์กลับมาให้แพทย์วิเคราะห์ผล ซึ่งจะใช้เวลาประมาณ 1-2 สัปดาห์</li>
      </ul>
      <p>ข้อดีของการตรวจ Holter Monitoring</p>
      <ul>
       <li>ตรวจพบความผิดปกติได้แม่นยำ: เนื่องจากการตรวจดำเนินการตลอด 24 ชั่วโมง จึงสามารถตรวจพบความผิดปกติที่เกิดขึ้นเป็นครั้งคราวได้</li>
       <li>สะดวกสบาย: คุณสามารถทำกิจวัตรประจำวันได้ตามปกติขณะทำการตรวจ</li>
       <li>ไม่เจ็บปวด: การติดตั้งอุปกรณ์ไม่ก่อให้เกิดความเจ็บปวด</li>
      </ul>
      <p>หากคุณมีข้อสงสัยเพิ่มเติมเกี่ยวกับการตรวจ Holter Monitoring สามารถปรึกษาแพทย์ได้</p>
      <p><strong>หมายเหตุ:</strong> ข้อมูลนี้เป็นเพียงข้อมูลทั่วไป ไม่ควรถือเป็นคำแนะนำทางการแพทย์ ควรปรึกษาแพทย์เพื่อรับคำแนะนำที่เหมาะสมกับสภาพร่างกายของคุณ</p>
      </>    
  ), 
},
  { src: require("./images/image5.jpg"), 
    alt: "การตรวจวิ่งสายพาน (Exercise stress test - EST)", 
    description:  (
<>
<p>การตรวจ Exercise Stress Test: ตรวจหัวใจขณะออกกำลังกาย</p>
<p>Exercise Stress Test หรือการตรวจหัวใจขณะออกกำลังกาย เป็นการตรวจเพื่อประเมินความสามารถของหัวใจในการทำงานขณะออกกำลังกาย โดยแพทย์จะติดตามอาการต่างๆ ของผู้เข้ารับการตรวจ เช่น อัตราการเต้นของหัวใจ ความดันโลหิต และคลื่นไฟฟ้าหัวใจ (ECG) ขณะที่ผู้เข้ารับการตรวจกำลังออกกำลังกาย</p>
<p>เหตุผลที่ต้องทำการตรวจ Exercise Stress Test</p>
<ul>
 <li>ตรวจหาโรคหลอดเลือดหัวใจตีบ: การตรวจนี้สามารถช่วยตรวจพบความผิดปกติของหลอดเลือดหัวใจที่อาจส่งผลให้เลือดไหลเวียนไปเลี้ยงหัวใจได้ไม่เพียงพอ</li>
 <li>ประเมินความเสี่ยงต่อการเกิดโรคหัวใจ: การตรวจนี้สามารถช่วยประเมินความเสี่ยงต่อการเกิดโรคหัวใจในอนาคตได้</li>
 <li>ประเมินประสิทธิภาพของการรักษา: หากคุณกำลังรับการรักษาโรคหัวใจ การตรวจนี้สามารถช่วยประเมินประสิทธิภาพของการรักษาได้</li>
</ul>
<p>ขั้นตอนการตรวจ</p>
<ul>
 <li>เตรียมตัว: คุณอาจต้องงดรับประทานอาหารและเครื่องดื่มที่มีคาเฟอีนก่อนการตรวจ</li>
 <li>ติดตั้งอุปกรณ์: แพทย์จะติดแผ่นอิเล็กโทรดขนาดเล็กเข้ากับผิวหนังบริเวณหน้าอก เพื่อเชื่อมต่อกับเครื่องตรวจคลื่นไฟฟ้าหัวใจ</li>
 <li>ออกกำลังกาย: คุณจะต้องออกกำลังกายบนเครื่องเดินหรือเครื่องปั่นจักรยาน โดยความเร็วและความหนักของการออกกำลังกายจะค่อยๆ เพิ่มขึ้นตามความสามารถของคุณ</li>
 <li>วิเคราะห์ผล: แพทย์จะวิเคราะห์ผลการตรวจและแจ้งผลให้คุณทราบ</li>
</ul>
<p>ข้อดีของการตรวจ Exercise Stress Test</p>
<ul>
 <li>ตรวจพบความผิดปกติได้แม่นยำ: การตรวจนี้สามารถตรวจพบความผิดปกติของหัวใจที่อาจเกิดขึ้นขณะออกกำลังกายได้</li>
 <li>ไม่เจ็บปวด: การตรวจนี้โดยทั่วไปไม่ก่อให้เกิดความเจ็บปวด</li>
</ul>
<p>หากคุณมีข้อสงสัยเพิ่มเติมเกี่ยวกับการตรวจ Exercise Stress Test สามารถปรึกษาแพทย์ได้</p>
</>
    ), 
  },
  { src: require("./images/image6.jpg"), 
    alt: "การตรวจสวนหัวใจ (coronary angiography - CAG)", 
    description:  (
<>
<p>การสวนหัวใจ เป็นวิธีการตรวจและรักษาโรคหลอดเลือดหัวใจตีบ โดยแพทย์จะสอดสายสวนขนาดเล็กเข้าไปในหลอดเลือดเพื่อตรวจสอบตำแหน่งที่หลอดเลือดตีบแคบ และอาจทำการขยายหลอดเลือดที่ตีบได้ทันที</p>
<p><strong>ประโยชน์ของการสวนหัวใจ:</strong></p>
<ul>
<li>ตรวจหาโรค: ช่วยให้แพทย์เห็นภาพของหลอดเลือดหัวใจได้ชัดเจน เพื่อวินิจฉัยโรคได้อย่างแม่นยำ</li>
<li>รักษาโรค: สามารถขยายหลอดเลือดที่ตีบแคบได้ทันที ทำให้เลือดไหลเวียนไปเลี้ยงหัวใจได้ดีขึ้น</li>
<li>ลดอาการ: ช่วยลดอาการเจ็บหน้าอก ใจสั่น หายใจลำบาก ที่เกิดจากโรคหลอดเลือดหัวใจตีบ</li>
<li>เพิ่มคุณภาพชีวิต: ผู้ป่วยจะมีคุณภาพชีวิตที่ดีขึ้น สามารถทำกิจวัตรประจำวันได้ตามปกติ</li>
</ul>
<p><strong>ขั้นตอนการสวนหัวใจ:</strong></p>
<ul>
<li>เตรียมตัว: ผู้ป่วยจะได้รับยาชาเฉพาะที่บริเวณที่สอดสายสวน</li>
<li>สอดสายสวน: แพทย์จะสอดสายสวนขนาดเล็กเข้าไปในหลอดเลือดแดงที่ขาหนีบหรือข้อมือ</li>
<li>ฉีดสี: ฉีดสารทึบรังสีเข้าไปในหลอดเลือด เพื่อให้เห็นภาพหลอดเลือดหัวใจชัดเจนขึ้น</li>
<li>ขยายหลอดเลือด: หากพบว่าหลอดเลือดตีบแคบ แพทย์จะใช้บอลลูนขยายหลอดเลือด หรือใส่ขดลวดขยายหลอดเลือด (stent)</li>
<li>สิ้นสุดการรักษา: ดึงสายสวนออกและกดที่บริเวณที่สอดสายสวน เพื่อหยุดเลือดไหล</li>
</ul>
<p><strong>ข้อควรระวัง:</strong></p>
<ul>
<li>การสวนหัวใจมีภาวะแทรกซ้อนได้ เช่น เลือดออก การติดเชื้อ แต่มีความเสี่ยงน้อยมาก</li>
<li>หลังการสวนหัวใจ ผู้ป่วยควรพักผ่อนตามที่แพทย์แนะนำ และทานยาตามที่แพทย์สั่ง</li>
<li>หากคุณมีอาการเจ็บหน้าอก ใจสั่น หายใจลำบาก ควรปรึกษาแพทย์เพื่อรับการตรวจวินิจฉัยและรักษาที่ถูกต้อง</li>
</ul>
<p><strong>หมายเหตุ:</strong></p>
<ul>
<li>ข้อมูลนี้เป็นเพียงข้อมูลทั่วไป ไม่สามารถใช้ทดแทนคำแนะนำของแพทย์ได้</li>
<li>ต้องการข้อมูลเพิ่มเติมเกี่ยวกับการสวนหัวใจ สามารถสอบถามแพทย์ผู้เชี่ยวชาญได้โดยตรง</li>
</ul>
</>
    ),
   },
];

const InteractiveImageGrid = () => {
  const [show, setShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setSelectedItem(item);
    setShow(true);
  };

  return (
    <section className="image-grid-section my-5">
      <Container>
        <h2 className="text-center mb-4">การตรวจโดยผู้เชี่ยวชาญเพื่อหาสาเหตุของโรคหัวใจ</h2>
        <Row>
          {imageData.map((item, index) => (
            <Col key={index} md={4} className="d-flex flex-column align-items-center mb-4">
              <div className="interactive-image">
                {/* ภาพ */}
                <img src={item.src} alt={item.alt} className="grid-image img-fluid" />
                {/* ชื่อภาพ */}
                <p>{item.alt}</p>
                {/* ปุ่มเปิด Offcanvas */}
                <Button variant="primary" onClick={() => handleShow(item)}>
                  ดูรายละเอียด
                </Button>
              </div>
            </Col>
          ))}
        </Row>

        {/* Offcanvas Component */}
        <Offcanvas show={show} onHide={handleClose} scroll={true} backdrop={false}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>{selectedItem?.alt}</Offcanvas.Title> {/* ชื่อหัวข้อ */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <p>{selectedItem?.description}</p> {/* แสดงรายละเอียด */}
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </section>
  );
};

export default InteractiveImageGrid;
